import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useContextSystem } from '@wp-g2/context';
import { cx } from '@wp-g2/styles';
import { useFormGroupContextId } from '../FormGroup';
import { useText } from '../Text';
import * as styles from './ControlLabel.styles';
export function useControlLabel(props) {
  var _useContextSystem = useContextSystem(props, 'ControlLabel'),
      htmlForProp = _useContextSystem.htmlFor,
      _useContextSystem$isB = _useContextSystem.isBlock,
      isBlock = _useContextSystem$isB === void 0 ? false : _useContextSystem$isB,
      _useContextSystem$siz = _useContextSystem.size,
      size = _useContextSystem$siz === void 0 ? 'medium' : _useContextSystem$siz,
      _useContextSystem$tru = _useContextSystem.truncate,
      truncate = _useContextSystem$tru === void 0 ? true : _useContextSystem$tru,
      otherProps = _objectWithoutProperties(_useContextSystem, ["htmlFor", "isBlock", "size", "truncate"]);

  var _useText = useText(_objectSpread(_objectSpread({}, otherProps), {}, {
    isBlock: isBlock,
    truncate: truncate
  })),
      className = _useText.className,
      textProps = _objectWithoutProperties(_useText, ["className"]);

  var htmlFor = useFormGroupContextId(htmlForProp);
  var classes = cx(styles.ControlLabel, styles[size], className, isBlock ? styles.block : styles.inline);
  return _objectSpread(_objectSpread({}, textProps), {}, {
    className: classes,
    htmlFor: htmlFor
  });
}